import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'aid-card-item',
  template: `
    <div class="aid-layout-row aid-layout-align-start-center">
      <div
        [ngClass]="{
          item__disabled: disabled
        }"
        class="item__element item__element--border full-width padding-vertical-16 aid-layout-row aid-layout-align-start-center"
        (click)="onSelect()"
      >
        <div
          class="mat-subtitle-2 item__element--color aid-layout-row aid-layout-align-start-center aid-layout-gap-16"
          [ngClass]="{
            'item__element--color': !selected
          }"
        >
          @if (icon) {
            <mat-icon
              [svgIcon]="icon"
              [ngClass]="{ 'item__disabled--color': disabled }"
            >
            </mat-icon>
          }
          <span [ngClass]="{ 'item__disabled--color': disabled }">
            {{ name | translate }}
          </span>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./card-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CardItemComponent implements OnInit {
  @Input() name?: string;
  @Input() icon?: string;
  @Input() selected = false;
  @Input() disabled?: boolean;

  @Output() select = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onSelect() {
    if (this.disabled) {
      return;
    }
    this.select.emit();
  }
}
